"use client";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import styles from "./index.module.scss";

export default function BackToTop() {
	const [visible, setVisible] = useState(false);
	const pathname = usePathname();

	useEffect(() => {
		const update = () => setVisible(window.scrollY > 400);
		update();
		window.addEventListener("scroll", update, { passive: true });
		return () => window.removeEventListener("scroll", update);
	}, [pathname]);

	if (!visible) return null;

	return (
		<button
			type="button"
			className={styles.button}
			aria-label="Наверх"
			title="Наверх"
			onClick={() => window.scrollTo({
				top: 0,
				behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
			})}
		>
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
				<path d="M5 12l7-7 7 7M12 5v15" />
			</svg>
		</button>
	);
}
